import * as yup from 'yup'

export const currencyValidationSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  iso3: yup.string().max(3, 'Max length is 3 characters').required('ISO3 is required'),
  symbol: yup.string().required('Symbol is required'),
  localisedSymbol: yup.string().required('Localised Symbol is required'),
})
